function getAllMatches(regex, string) {
  const matches = []
  let m
  do {
    m = regex.exec(string)
    // console.log(m)
    if (m) matches.push(m)
  } while (m)
  return matches
}

export { getAllMatches }
